<!--
 * @Description: 
 * @Author: dinghao
 * @Date: 2022-03-28 13:37:26
 * @LastEditTime: 2022-03-31 16:07:08
 * @LastEditors: dinghao
-->
<template>
  <div class="main">
    <baidu-map
      id="allmap"
      @ready="mapReady"
      @zoomend="zoomend"
      @dragend="dragend"
      :min-zoom="5"
      :scroll-wheel-zoom="true"
      :double-click-zoom="true"
    >
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
      <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
      <!-- 省 provice -->
      <template v-if="Na < 7 && Na >= 5 &&  proviceLable">
        <template v-for="(marker, index) in markers">
          <bm-label
            v-if="marker.ai == 0"
            :key="index"
            :position="{ lng: marker.lng, lat: marker.lat }"
            :massClear="true"
            :content="marker.content"
            :labelStyle="{...labelcss,}"
            @click="jumpArea"
            :offset="{ width: -25, height: -20 }"
          />
          <bm-label
            v-else
            :key="index"
            :position="{ lng: marker.lng, lat: marker.lat }"
            :massClear="true"
            :content="marker.content"
            :labelStyle="{...labelcssAI}"
            @click="jumpArea"
            :offset="{ width: -25, height: -20 }"
          />
        </template>
      </template>
      <!-- 市 -->
      <template v-if="Na < 12 && Na >=7 && cityLable">
        <template v-for="(marker, index) in markers">
          <bm-label
            v-if="marker.ai == 0"
            :key="index"
            :position="{ lng: marker.lng, lat: marker.lat }"
            :massClear="true"
            :content="marker.content"
            :labelStyle="labelcss2"
            @click="jumpArea"
            :offset="{ width: -25, height: -20 }"
          />
          <bm-label
            v-else
            :key="index"
            :position="{ lng: marker.lng, lat: marker.lat }"
            :massClear="true"
            :content="marker.content"
            :labelStyle="labelcss2AI"
            @click="jumpArea"
            :offset="{ width: -25, height: -20 }"
          />
        </template>
      </template>
      <!-- 区 -->
      <template v-if="Na < 14 && Na >=12 && areaLable">
        <template v-for="(marker, index) in markers">
          <bm-label
            v-if="marker.ai == 0"
            :key="index"
            :position="{ lng: marker.lng, lat: marker.lat }"
            :massClear="true"
            :content="marker.content"
            :labelStyle="labelcss3"
            @click="jumpArea"
            :offset="{ width: -25, height: -20 }"
          />
          <bm-label
            v-else
            :key="index"
            :position="{ lng: marker.lng, lat: marker.lat }"
            :massClear="true"
            :content="marker.content"
            :labelStyle="labelcss3AI"
            @click="jumpArea"
            :offset="{ width: -25, height: -20 }"
          />
        </template>
      </template>
      <!-- 公司 -->
      <template v-if=" Na >=14 && streetLable">
        <template v-for="(marker, index) in markers">
          <bm-label
            v-if="marker.ai == 0"
            :key="index"
            :position="{ lng: marker.lng, lat: marker.lat }"
            :massClear="true"
            :content="marker.content"
            :labelStyle="labelcss4"
            @click="goCompany(marker)"
            :offset="{ width: -25, height: -20 }"
          />
           <bm-label
            v-else
            :key="index"
            :position="{ lng: marker.lng, lat: marker.lat }"
            :massClear="true"
            :content="marker.content"
            :labelStyle="labelcss4AI"
            @click="goCompany(marker)"
            :offset="{ width: -25, height: -20 }"
          />
        </template>
      </template>
      
    </baidu-map>
    <div class="absolute">
      <van-icon @click="show = true;cityList.splice(0,-1)" name="bars" size="2rem" />
      <van-icon @click="showSearch = true" name="search" size="2rem" />
      <van-icon @click="back" name="wap-home-o" size="2rem" />
    </div>
    <div class="absolute logo">
      <img src="../assets/icon.png" alt="">
    </div>
    <p class="top">
    一共服务<span style=" font-weight: bold;">{{all}}</span>家小店</p>
    <div class="phb">
      <div class="item" v-for="(item,index) in topList" :key="index" >
        <span :class="'name'+index "> {{index+1}} </span> {{item.province}} 
      </div>
    </div>

    <!-- 条件筛选框 -->
    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '80%' }"
      closeable
    >
      <h3 class="title">地区内共有 {{number}} 家企业</h3>
      <van-collapse v-model="activeNames">
        <van-collapse-item title="地区" :name="showCollapse">
          <div class="select-box" >
            <Select placeholder="请选择省" v-model="provice" @on-change="selsectPre" style="width: 200px">
              <Option v-for="(item,index) in proviceList" :value="item.value" :key="index">
                {{item.label}}
              </Option>
            </Select>
            <Select placeholder="请选择市"  v-model="city"  @on-change="selectCity"  style="width: 200px">
              <Option v-for="(item,index) in cityList" :value="item.value" :key="index">
                {{item.label}}
              </Option>
            </Select>
            <Select placeholder="请选择区"  v-model="area" style="width: 200px">
              <Option v-for="(item,index) in areaList" :value="item.value" :key="index">
                {{item.label}}
              </Option>
            </Select>
            <div class="btn-group">
              <van-button class="sure" type="info" round @click="searchCommpany">确定</van-button>
              <van-button class="repaly" icon="replay" @click="replay" color="grba(0,0,0,0)" >重置</van-button>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
      <div class="company-list" v-if="commpanyList.length">
        <div class="company-item" v-for="(item, index) in commpanyList" :key="index"
         @click="goCompany(item)">
          <img src="../assets/p1.jpg" alt="">
          <div class="company-info" >
            <div class="company-title">{{item.commpany}}</div>
            <div class="company-add">{{item.province}}|{{item.city}}|{{item.area}}</div>
            <div class="company-add">{{item.category}}</div>
          </div>
        </div>
      </div>
      <div v-else class="text-tips">
        按顺序依次选择省、市、区进行区域筛选
      </div>
    </van-popup>
    <!-- 搜索框 -->
    <van-popup
      v-model="showSearch"
      round
      position="bottom"
      :style="{ height: '90%' }"
      :close-on-click-overlay = false
    >
      <div style="height: 69px;background: #ffffff">
        <van-search
          v-model="search"
          show-action
          placeholder="请输入公司名称关键词进行搜索"
          @search="onSearch"
          @cancel="onCancel"
        />
      </div>
      <div class="list" v-if="commpanyList.length">
        <div class="company-item" v-for="(item, index) in commpanyList" :key="index"
        @click="goCompany(item)">
          <div class="company-info" >
            <div class="company-title">{{item.commpany}}</div>
            <div class="company-add">{{item.province}}|{{item.city}}|{{item.area}}</div>
            <!-- <div class="company-add">{{item.category}}</div> -->
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>


<script>
import json from "@/utils/data.js"
import { Toast } from 'vant';
// import {styleJson} from "@/utils/styleJson.js"
import { BmlMarkerClusterer } from "vue-baidu-map";
export default {
  name: "HelloWorld",
  components: {
    BmlMarkerClusterer,
  },
  data() {
    return {
      topList: [],
      showCollapse: "1",
      proviceLable: false, // 省标签
      cityLable: false, // 市标签
      areaLable: false, // 区标签
      streetLable: false, // 公司标签
      companyLable: false, // 留一个标签
      provice: '', // 省
      city:'', // 市
      area:'', // 区
      proviceList: [ ],
      cityList:[],
      areaList:[],
      show: false, // 地区弹窗
      activeNames: ['1'],
      point: "",
      markers: [
       
      ],
      labelcss: {
        width: "45px",
        height: "45px",
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "15px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgb(26,152,5,.8)",
      },
      labelcssAI: {
        width: "45px",
        height: "45px",
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "15px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgba(153, 91, 255, 0.69)",
      },
      labelcss2: { // 市级
        width: "60px",
        height: "60px",
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "15px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgb(26,152,5,.8)",
      },
      labelcss2AI: { // 市级
        width: "60px",
        height: "60px",
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "15px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgba(153, 91, 255, 0.69)",
      },
      labelcss3: { // 县
        width: "70px",
        height: "70px",
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "15px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgb(26,152,5,.8)",
      },
      labelcss3AI: { // 县
        width: "70px",
        height: "70px",
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "15px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgba(153, 91, 255, 0.69)",
      },
      labelcss4: { // 公司
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        alignItems: "center",
        lineHeight: "15px",
        padding:"5px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgb(26,152,5,.8)",
      },
      labelcss4AI: { // 公司
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        alignItems: "center",
        lineHeight: "15px",
        padding:"5px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgba(153, 91, 255, 0.69)",
      },
      map: {}, // 百度地图对象
      Na: 0, // 当前地图等级
      center: {}, // 当前地图中心点
      commpanyList: [],
      number: 0, // 地区企业数量
      showSearch: false,
      search: '',
      all: 0

    };
  },
  methods: {
    back() {
      location.href = `https://jiuye.lqsaa.com/shops/serve/index.html#/about`
    },
    // 开始准备地图
    mapReady({ BMap, map }) {
      if(!this.$route.query.zoom){
        this.map = map;
        this.Na = map.Na;
        this.point = new BMap.Point(116.2, 39.56); // 初始化地图,设置中心点坐标和地图级别
        map.centerAndZoom(new BMap.Point(116.404, 39.915), 5); // 设置中心店并设置缩放级别
        this.center = this.map.getCenter()
        map.addEventListener('click', function (e) {
        //  console.log(e.point);
        });
      } else {
        console.log(123);
        this.map = map;
        this.Na = map.Na;
        map.centerAndZoom(new BMap.Point(this.$route.query.lng, this.$route.query.lat), 14); // 设置中心店并设置缩放级别
        this.center = this.map.getCenter()
      }
    },
    // 设置所有级别的lable不可见
    noshow(){
      this.proviceLable = false
      this.cityLable = false
      this.areaLable = false
      this.streetLable = false
      this.companyLable = false
    },
    // 停止拖拽地图触发
    async dragend(e) {
      console.log(this.center.lat,this.center.lng);
      if (e.target.Na >= 14){
        if(Math.abs(e.target.getCenter().lat - this.center.lat) >= 0.01|| 
        Math.abs(e.target.getCenter().lng - this.center.lng) >= 0.01 ) {
          this.noshow()
          this.center = e.target.getCenter()
          let res = await this.$api.get( `/shops/api.php?n=0.1&zoom=14&lat=${this.center.lat}&lng=${this.center.lng}`)
          this.markers = res.data.map(item=> {
            if(item.ai == 1) {
              item.content = `
              <div style="display: flex; align-items: center">
                  <img width="17" style="margin-right: 6px" src="https://jiuye.lqsaa.com/shops/d_icon.png" />
                  <span>${item.commpany}</span>
                </div>`
              return item
            } else {
              item.content = `
              <div >
                  <span>${item.commpany}</span>
                </div>`
              return item
            }
          })
          //  this.markers[0].lat = new Number(this.markers[0].lat) + 0.0005
          //  console.log(this.markers);
            this.streetLable = true
          }
      }
      else if (e.target.Na >= 12){
         if(Math.abs(e.target.getCenter().lat - this.center.lat) >= 0.1|| 
        Math.abs(e.target.getCenter().lng - this.center.lng) >= 0.1 ) {
          this.noshow()
          this.center = e.target.getCenter()
          let res = await this.$api.get( `/shops/api.php?n=0.5&zoom=12&lat=${this.center.lat}&lng=${this.center.lng}`)
          this.markers = res.data.map(item=> {
            item.content = `
            <div style="display:flex;flex-direction:column;align-items:center;justify-content: center; width:50px;height: 100%;text-align:center">
              <span>${item.area}</span>
              <div>${item.c}家</div>
            </div>`
            return item
          })
          this.areaLable = true
          }
       
      }else if(this.Na >= 7 ) {
        if(Math.abs(e.target.getCenter().lat - this.center.lat) >= 1|| 
        Math.abs(e.target.getCenter().lng - this.center.lng) >= 1 ) {
          this.noshow()
          this.center = e.target.getCenter()
          let res = await this.$api.get( `/shops/api.php?n=3&zoom=7&lat=${this.center.lat}&lng=${this.center.lng}`)
          console.log(res);
          this.markers = res.data.map(item=> {
            item.content = `
            <div style="display:flex;flex-direction:column;align-items:center;justify-content: center; width:50px;height: 100%;text-align:center">
              <span>${item.city}</span>
              <div>${item.c}家</div>
            </div>`
            return item
          })
          this.cityLable = true
        }
        
      }
    },
    // 监听级别改变
    async zoomend(e) {
      this.Na = e.target.Na;
      this.center = this.map.getCenter()
      console.log(this.Na );
      this.noshow()
      if (e.target.Na >= 14){
        let res = await this.$api.get( `/shops/api.php?n=0.1&zoom=14&lat=${this.center.lat}&lng=${this.center.lng}`)
        this.markers = res.data.map(item=> {
          if(item.ai == 1) {
            item.content = `
            <div style="display: flex; align-items: center">
                <img width="17" style="margin-right: 6px" src="https://jiuye.lqsaa.com/shops/d_icon.png" />
                <span>${item.commpany}</span>
              </div>`
            return item
          }else {
            item.content = `
            <div >
                <span>${item.commpany}</span>
              </div>`
          }
            return item
        })
        this.markers[0].lat = new Number(this.markers[0].lat) + 0.0001
        setTimeout(() => {
          this.streetLable = true
        }, 0);
      } else if (e.target.Na >= 12){
        let res = await this.$api.get( `/shops/api.php?n=0.5&zoom=12&lat=${this.center.lat}&lng=${this.center.lng}`)
        this.markers = res.data.map(item=> {
          item.content = `
          <div style="display:flex;flex-direction:column;align-items:center;justify-content: center; width:50px;height: 100%;text-align:center">
            <span>${item.area}</span>
            <div>${item.c}家</div>
          </div>`
          return item
        })
        setTimeout(() => {
          this.areaLable = true
        }, 0);
      } else if(e.target.Na >= 7) {
        // 获取中心点
        let res = await this.$api.get( `/shops/api.php?n=3&zoom=7&lat=${this.center.lat}&lng=${this.center.lng}`)
        console.log(res);
        
        this.markers = res.data.map(item=> {
          item.content = `
          <div style="display:flex;flex-direction:column;align-items:center;justify-content: center; width:50px;height: 100%;text-align:center">
            <span>${item.city}</span>
            <div>${item.c}家</div>
          </div>`
          return item
        })
        setTimeout(() => {
          this.cityLable = true
        }, 0);
      } else if(e.target.Na >= 5){
        this.cityLable = false
        this.areaLable = false
        // 省区域接口
        let res = await this.$api.get('/shops/api.php?n=5&zoom=1&lat=123&lng=233')
        this.markers = res.data.map(item=> {
          item.content = `
          <div style="display: flex;flex-direction:column;align-items:center;justify-content: center;width:50px;height: 100%;text-align:center">
            <span>${item.province}</span>
            <div>${item.c}家</div>
          </div>`
          return item
        })
        setTimeout(() => {
          this.proviceLable = true
        }, 0);
      }
    },
    // 点击标签地图做层级跳转
    jumpArea(e) {
      let na;
      if (this.map.Na > 0 && this.map.Na < 6) {
        na = 7;
        this.Na = na
      } else if (this.map.Na >= 6 && this.map.Na < 11) {
        na = 12;
        this.Na = na
      } else if (this.map.Na >= 11 && this.map.Na <= 13) {
        na = 14;
        this.Na = na
      } 
      this.map.setZoom(na);
      this.map.setCenter(new BMap.Point(e.target.point.lng, e.target.point.lat));
    },
    // 跳转公司页
    goCompany(item) {
      if(item.url) {
        location.href = item.url
      } else {
        this.$router.push({
          name:"name" ,
          query:item
        })
      }
      
    },
    // 省份查询
    selsectPre(value) {
      console.log(this.cityList);
      this.cityList =[]
      this.$api.get(`/shops/area.php?province=${value}`)
      .then(res=> {
        this.cityList = res.data.map(item=> {
          let obj ={}
          obj.value = item
          obj.label = item
          return obj
        })
      })
    },
    // 查询市区
    selectCity(value) {
      this.$api.get(`/shops/area.php?province=${this.provice}&city=${value}`)
      .then(res=> {
        this.areaList = res.data.map(item=> {
          let obj ={}
          obj.value = item
          obj.label = item
          return obj
        })
      })
    },
    // 查询公司
    searchCommpany() {
      this.commpanyList = []
      if(this.show) {
        if(!(this.provice.length ==0)) {
          this.$api.get(`/shops/find.php?province=${this.provice}&city=${this.city}&area=${this.area}`)
          .then(res => {
            this.commpanyList = res.data
            this.number = res.data.length
          })
        } else {
          console.log(1);
          Toast("省份不能为空")
        }
      } else {
        this.$api.get(`/shops/find.php?key=${this.search}`)
          .then(res => {
            this.commpanyList = res.data
            this.number = res.data.length
          })
      }
    },
    // 重置选项
    replay() {
      this.provice = ''
      this.city = ''
      this.area = ''
    },
    onSearch(val) {
      this.searchCommpany()
    },
    onCancel() {
      this.showSearch = false
      this.search = ''
      this.commpanyList = []
      this.number = 0
    },
  },
  created() { 
    this.$api.get('/shops/api.php?n=5&zoom=1&lat=123&lng=233')
    .then(res=> {
      this.markers = res.data
      this.topList = res.data 
      console.log( this.topList);
      this.topList = res.data.sort((a,b) => {
        return b.c- a.c
      })
       res.data.map(item=> {
         this.all +=(item.c)*1
       })
      this.topList.splice(5)
    })
    this.$api.get('/shops/area.php')
    .then(res=> {
      this.proviceList = res.data.map(item=> {
        let obj ={}
        obj.value = item
        obj.label = item
        return obj
      })
    })

  }
};
</script>

<style scoped>
.main {
  font-size: 16px;
  color: #333;
}
#allmap {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.absolute {
  position: absolute;
  bottom: 20vh;
  /* width: 25px; */
  display: flex;
  flex-direction: column;
  background-color: #fff;
  right: 15px;
  border-radius: 10px;
  padding: 5px;
  align-items: center;
}
.absolute i{
  margin: 5px 0;
}

.title {
  text-align: center;
  margin: 20px;
}
.select-box {
  display: flex;
  flex-direction: column;
  margin: 10px;
}
.select-box > div {
  margin-bottom: 10px;
}
/* .show-select {
  
} */
.company-list {
  margin: 5px 15px;
}
.company-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e7e7e7;
}
.company-item img{
  display: block;
  width: 120px;
  height: 90px;
  border: 1px solid #dcdee2;
  border-radius: 5px;
}
.company-info {
  margin-left: 10px;
}
.company-info .company-title{
  font-size: 15px;
  color: #333;
  font-weight: bold;
}
.company-info .company-add {
  font-size: 14px;
  color: #7b7b7b
}
.logo {
  bottom: 5px;
  left: 5px;
  width:70px;
  background: transparent;
}
.logo img {
  width: 60px;
}
.van-search {
  position: fixed;
  width: 100%;
  padding: 15px 15px;
  border-radius: 15px 15px 0 0;
  background: #ffffff;
}
.btn-group {
  display: flex;
  align-items: center;
}
.van-button >>> .van-button__content {
  flex-direction: column;
}
.sure {
  width: 150px;
}
.repaly  .van-button__content{
  color: #666;
} 
.btn-group >>> .van-button--default{
  border: 0px solid red ;
} 
.list {
  margin: 0 15px;
}
.main>>>.anchorBL {
  display: none;
}
.main>>>.BMap_cpyCtrl {
  display:none;
}
.text-tips {
  text-align: center;
  color: #7b7b7b;
  font-size: 14px;
  padding: 20px;
}
.phb {
  position: absolute;
  top: 20%;
  right: 15px;
  width: 60px;
  height: 150px;
  background-image: url("../assets/phb.png");
  background-size: 100% 100%;
}
.item {
  color: #333333;
  margin: 2px;
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: center;
}
.item:first-child{
  margin-top: 30px;
}
.item span {
  display: inline-block;
  font-size: 14px;
  width: 16px;

  text-align: center;
  margin-right: 5px;
}
.name0 {
  border-radius: 50%;
  height: 16px;
  width: 16px;
  line-height: 16px;
  background-color:#ffe907;
}
.name1 {
  border-radius: 50%;
  height: 16px;
  width: 16px;
  line-height: 16px;
  background-color: #cbc9cc;
}
.name2 {
  border-radius: 50%;
  height: 16px;
  width: 16px;
  line-height: 16px;
  background-color: #ffa457;
}
.top {
  position: absolute;
  top: 15%;
  padding: 0 15px;
  background-color: #fff;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 15px;
  box-shadow: 0px 0px 5px rgba(0,0,0,.5);
  width: 11.5em;
}
</style>